<!-- <div class="card primary-background d-flex jc-center ai-center fd-col">

  <div class="padded flex-1 order--1 d-flex jc-center ai-center">
    <img class="banner-image" [src]="tileInstance.imgUri">
  </div>

  <h2 class="padded">{{ tileInstance.heading }}</h2>

  <a [routerLink]="['..', tileInstance.routeLink]" class="padded link"> {{ tileInstance.linkText }} </a>


</div> -->
<div class="d-flex fd-col jc-between ai-stretch" [class.card]="shouldShowCard">
  <div class="d-flex fd-row ai-center">
    <h4>
      <mat-icon *ngIf="tileInstance?.headingIcon" class="border-circle">
        {{ tileInstance?.headingIcon }}
      </mat-icon>
    </h4>

    <div class="display-heading d-flex fd-col ai-start" [class.ticking]="ticking">
      <p class="display-number" *ngIf="displayNumber">{{ displayNumber | number: '1.0-0' }}</p>
      <p class="display-number" *ngIf="!displayNumber">1000 +</p>
      <p class="display-feature" style="flex: 0 0 auto">{{ tileInstance?.heading }}</p>
    </div>
  </div>

  <div class="d-flex fd-col ai-start ai-stretch">
    <!-- <div class="d-flex flex-wrap ai-center gap-8">
      <p class="flex-1">{{ tileInstance.subHeading }}</p>
    </div> -->
    <button
      class="button"
      mat-stroked-button
      color="primary"
      [routerLink]="tileInstance?.routeLink"
    >
      {{ tileInstance?.linkText }}
    </button>
  </div>
</div>
